import { useState } from "react";
import { Link } from "react-router-dom";
import { Rocket, EyeSlash, ArrowSquareOut } from "@phosphor-icons/react";
import { toast } from "sonner";
import { Section } from "@/components/builder/IdentitySection";
import { api, errMsg, fmtEur, fmtPrice } from "@/lib/api";

const TYPES = [["one_time", "Pago único"], ["monthly", "Suscripción mensual"], ["free", "Gratis"]];

export const PublishSection = ({ agent, onUpdated, ensureSaved }) => {
  const [type, setType] = useState(agent.published && !agent.price ? "free" : agent.pricing_type || "one_time");
  const [price, setPrice] = useState(agent.price || 29);
  const [busy, setBusy] = useState(false);
  const p = type === "free" ? 0 : Number(price) || 0;

  const publish = async () => {
    if (type !== "free" && p < 0.5) return toast.error("El precio mínimo es 0,50 €");
    setBusy(true);
    try {
      if ((await ensureSaved()) === false) { setBusy(false); return; }
      const { data } = await api.post(`/agents/${agent.agent_id}/publish`, { price: p, pricing_type: type === "free" ? "one_time" : type });
      onUpdated(data);
      toast.success(agent.published ? "Publicación actualizada" : "¡Agente publicado en el marketplace!");
    } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  const unpublish = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/agents/${agent.agent_id}/unpublish`); onUpdated(data); toast.success("Agente retirado del marketplace"); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };

  return (
    <Section id="publish" title="Publicación y precio" desc="Vende tu agente en el marketplace. Los compradores nunca ven tus instrucciones ni documentos.">
      {agent.published && (
        <div className="flex flex-wrap items-center justify-between gap-3 border border-emerald-500/30 bg-emerald-500/5 p-4" data-testid="publish-status-live">
          <div className="flex items-center gap-2 text-sm"><span className="h-2 w-2 bg-emerald-500" /> Publicado · <span className="font-mono">{fmtPrice(agent)}</span></div>
          <Link to={`/agent/${agent.agent_id}`} className="inline-flex items-center gap-1 text-sm text-emerald-400 hover:text-emerald-300" data-testid="publish-view-listing">Ver ficha <ArrowSquareOut size={14} /></Link>
        </div>
      )}
      <div>
        <label className="label">Modelo de precio</label>
        <div className="grid grid-cols-3 border border-white/10">
          {TYPES.map(([v, l]) => <button key={v} onClick={() => setType(v)} className={`py-2.5 text-sm ${type === v ? "bg-white text-black" : "text-zinc-400 hover:text-white"}`} data-testid={`publish-type-${v}`}>{l}</button>)}
        </div>
      </div>
      {type !== "free" && (
        <div>
          <label className="label">Precio (EUR){type === "monthly" ? " / mes" : ""}</label>
          <div className="flex items-center border border-white/10 bg-[#0d0d0d] focus-within:border-blue-500">
            <span className="px-3 font-mono text-zinc-500">€</span>
            <input type="number" min="0.5" step="0.5" value={price} onChange={(e) => setPrice(e.target.value)} className="h-11 flex-1 bg-transparent font-mono focus:outline-none" data-testid="publish-price-input" />
          </div>
        </div>
      )}
      <div className="grid grid-cols-3 border border-white/10">
        {[["Precio", fmtEur(p)], ["Comisión (15%)", `− ${fmtEur(p * 0.15)}`], ["Recibes", fmtEur(p * 0.85)]].map(([l, v], i) => (
          <div key={l} className="border-r border-white/10 p-4 last:border-r-0"><p className="text-[10px] uppercase tracking-widest text-zinc-500">{l}</p><p className={`mt-1 font-mono text-lg font-semibold ${i === 2 ? "text-emerald-400" : ""}`} data-testid={`publish-calc-${i}`}>{v}</p></div>
        ))}
      </div>
      <div className="flex flex-wrap gap-3">
        <button onClick={publish} disabled={busy} className="btn-primary !px-6 !py-3" data-testid="publish-button"><Rocket size={16} /> {busy ? "Procesando…" : agent.published ? "Actualizar publicación" : "Publicar en el marketplace"}</button>
        {agent.published && <button onClick={unpublish} disabled={busy} className="btn-ghost !py-3" data-testid="unpublish-button"><EyeSlash size={16} /> Retirar</button>}
      </div>
      <p className="text-xs text-zinc-600">Los pagos se procesan con Stripe. Los compradores existentes conservan su acceso aunque retires o modifiques el agente.</p>
    </Section>
  );
};
